<template>
  <footer class="nx-footer" id="contact">
    <div class="nx-footer-glow"></div>
    <div class="nx-footer-container">
      <!-- 标题区域 -->
      <div class="nx-footer-header">
        <p class="nx-footer-subtitle">CONTACT US</p>
        <h2 class="nx-footer-title">联系我们</h2>
        <p class="nx-footer-desc">期待与您合作，共创美好未来</p>
      </div>

      <div class="nx-footer-content">
        <!-- 联系信息 -->
        <div class="nx-footer-contact">
          <div class="nx-footer-contact-list">
            <div class="nx-footer-item">
              <div class="nx-footer-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 7C3 5.89543 3.89543 5 5 5H19C20.1046 5 21 5.89543 21 7V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V7Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  <path d="M3 7L12 13L21 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="nx-footer-text">
                <span class="nx-footer-label">邮箱</span>
                <span class="nx-footer-value">{{ config?.footer?.contact?.email }}</span>
              </div>
            </div>

            <div class="nx-footer-item">
              <div class="nx-footer-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="5" y="2" width="14" height="20" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 18H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="nx-footer-text">
                <span class="nx-footer-label">销售电话</span>
                <span class="nx-footer-value">{{ config?.footer?.contact?.phone }}</span>
              </div>
            </div>

            <div
              v-for="(address, index) in (config?.footer?.contact?.addresses || [])"
              :key="'addr-' + index"
              class="nx-footer-item"
            >
              <div class="nx-footer-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="12" cy="9" r="2.5" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
              <div class="nx-footer-text">
                <span class="nx-footer-label">{{ address.label }}</span>
                <span class="nx-footer-value">{{ address.value }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 微信联系 -->
        <div class="nx-footer-wechat">
          <div class="nx-footer-wechat-grid">
            <div
              v-for="(wx, index) in (config?.footer?.wechat || [])"
              :key="'wx-' + index"
              class="nx-footer-wechat-card"
              @mouseenter="showQrCode(index)"
              @mouseleave="hideQrCode"
            >
              <div class="nx-footer-wechat-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.5 11.5C9.32843 11.5 10 10.8284 10 10C10 9.17157 9.32843 8.5 8.5 8.5C7.67157 8.5 7 9.17157 7 10C7 10.8284 7.67157 11.5 8.5 11.5Z" fill="currentColor"/>
                  <path d="M14.5 11.5C15.3284 11.5 16 10.8284 16 10C16 9.17157 15.3284 8.5 14.5 8.5C13.6716 8.5 13 9.17157 13 10C13 10.8284 13.6716 11.5 14.5 11.5Z" fill="currentColor"/>
                  <path d="M12 2C6.5 2 2 5.5 2 9.5C2 11.5 3 13.5 4.5 15L3 17L6 16C7.5 16.5 9.5 17 11.5 17C17 17 21.5 13.5 21.5 9.5C21.5 5.5 17 2 12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <span class="nx-footer-wechat-label">{{ wx.label }}</span>
              <div class="nx-footer-wechat-qrcode" v-if="activeQrCode === index">
                <img :src="wx.qrcode" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部版权 -->
      <div class="nx-footer-bottom">
        <p class="nx-footer-copyright">{{ config?.site?.copyright }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'NxFooter',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      activeQrCode: null
    };
  },
  mounted() {
    // 组件已挂载，配置由父组件传递
  },
  methods: {
    showQrCode(index) {
      this.activeQrCode = index;
    },
    hideQrCode() {
      this.activeQrCode = null;
    }
  }
};
</script>

<style scoped>
.nx-footer {
  position: relative;
  background: linear-gradient(180deg, #f5f7fa 0%, #f8f9fa 100%);
  padding: 100px 40px 50px;
  overflow: hidden;
}

.nx-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 400px;
  background:
    radial-gradient(ellipse at top, rgba(59, 130, 246, 0.05) 0%, transparent 60%),
    radial-gradient(ellipse at 80% 20%, rgba(139, 92, 246, 0.04) 0%, transparent 50%);
  pointer-events: none;
}

.nx-footer-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background:
    linear-gradient(90deg,
      transparent 0%,
      #3b82f6 20%,
      #60a5fa 50%,
      #3b82f6 80%,
      transparent 100%);
  box-shadow:
    0 0 30px rgba(59, 130, 246, 0.6),
    0 0 60px rgba(59, 130, 246, 0.4);
  animation: glowLinePulse 4s ease-in-out infinite;
}

@keyframes glowLinePulse {
  0%, 100% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
}

.nx-footer-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.nx-footer-header {
  text-align: center;
  margin-bottom: 45px;
}

.nx-footer-subtitle {
  font-size: 1.2rem;
  color: var(--nx-blue-primary);
  font-weight: 500;
  letter-spacing: 0.3rem;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
  text-shadow: 0 0 20px rgba(25, 118, 210, 0.25);
}

.nx-footer-title {
  font-size: clamp(32px, 4.5vw, 48px);
  font-weight: 800;
  color: var(--nx-text-title);
  margin-bottom: 12px;
  text-shadow: 0 0 30px rgba(13, 71, 161, 0.15),
    0 0 60px rgba(59, 130, 246, 0.1);
  position: relative;
  display: inline-block;
}

.nx-footer-title::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(
    90deg,
    transparent,
    var(--nx-blue-primary),
    transparent
  );
}

.nx-footer-desc {
  font-size: 15px;
  color: #475569;
  letter-spacing: 1px;
  font-weight: 500;
}

.nx-footer-content {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 45px;
  margin-bottom: 45px;
  align-items: center;
}

.nx-footer-contact,
.nx-footer-wechat {
  display: flex;
  flex-direction: column;
}

.nx-footer-contact-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.nx-footer-item {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  padding: 8px 28px;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(248, 250, 255, 0.95) 100%);
  backdrop-filter: blur(30px);
  border: 2px solid rgba(59, 130, 246, 0.15);
  border-radius: 14px;
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow:
    0 6px 25px rgba(59, 130, 246, 0.1),
    0 0 35px rgba(59, 130, 246, 0.06);

  &:hover {
    transform: translateX(8px);
    border-color: rgba(59, 130, 246, 0.4);
    box-shadow:
      0 10px 35px rgba(59, 130, 246, 0.15),
      0 0 50px rgba(59, 130, 246, 0.1);

    .nx-footer-icon {
      background:
        linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
      border-color: rgba(59, 130, 246, 0.6);
      transform: scale(1.1);
      box-shadow:
        0 6px 20px rgba(59, 130, 246, 0.4),
        0 0 30px rgba(59, 130, 246, 0.3);

      svg {
        color: #ffffff;
        filter:
          drop-shadow(0 0 12px rgba(255, 255, 255, 0.8))
          drop-shadow(0 0 20px rgba(59, 130, 246, 0.6));
      }
    }
  }
}

.nx-footer-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(59, 130, 246, 0.08);
  border: 2px solid rgba(59, 130, 246, 0.18);
  border-radius: 12px;
  flex-shrink: 0;
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);

  svg {
    width: 22px;
    height: 22px;
    color: #3b82f6;
    filter: drop-shadow(0 0 8px rgba(59, 130, 246, 0.3));
    transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  }
}

.nx-footer-text {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.nx-footer-label {
  font-size: 12px;
  color: #3b82f6;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.nx-footer-value {
  font-size: 14px;
  color: #475569;
  line-height: 1.5;
  font-weight: 500;
}

.nx-footer-section-title,
.nx-footer-wechat-title {
  font-size: 15px;
  color: #1e293b;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 24px;
  line-height: 1.5;
}

.nx-footer-wechat-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.nx-footer-wechat-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 26px 20px;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(248, 250, 255, 0.95) 100%);
  backdrop-filter: blur(30px);
  border: 2px solid rgba(59, 130, 246, 0.15);
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow:
    0 6px 25px rgba(59, 130, 246, 0.1),
    0 0 35px rgba(59, 130, 246, 0.06);

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(59, 130, 246, 0.4);
    box-shadow:
      0 12px 40px rgba(59, 130, 246, 0.15),
      0 0 60px rgba(59, 130, 246, 0.1);

    .nx-footer-wechat-icon {
      background:
        linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
      border-color: rgba(59, 130, 246, 0.6);
      transform: scale(1.1);
      box-shadow:
        0 6px 20px rgba(59, 130, 246, 0.4),
        0 0 30px rgba(59, 130, 246, 0.3);

      svg {
        color: #ffffff;
        filter:
          drop-shadow(0 0 12px rgba(255, 255, 255, 0.8))
          drop-shadow(0 0 20px rgba(59, 130, 246, 0.6));
      }
    }
  }
}

.nx-footer-wechat-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(59, 130, 246, 0.08);
  border: 2px solid rgba(59, 130, 246, 0.18);
  border-radius: 12px;
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);

  svg {
    width: 20px;
    height: 20px;
    color: #3b82f6;
    filter: drop-shadow(0 0 8px rgba(59, 130, 246, 0.3));
    transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  }
}

.nx-footer-wechat-label {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  text-align: center;
}

.nx-footer-wechat-qrcode {
  position: absolute;
  bottom: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%);
  padding: 12px;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(30px);
  border: 2px solid rgba(59, 130, 246, 0.3);
  border-radius: 12px;
  box-shadow:
    0 12px 45px rgba(59, 130, 246, 0.18),
    0 0 60px rgba(59, 130, 246, 0.25);
  z-index: 100;
  animation: fadeInUp 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}

.nx-footer-wechat-qrcode img {
  width: 120px;
  height: 120px;
  display: block;
}

.nx-footer-bottom {
  display: flex;
  justify-content: center;
  padding-top: 40px;
  border-top: 1px solid rgba(59, 130, 246, 0.15);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    height: 2px;
    background:
      linear-gradient(90deg,
        transparent 0%,
        rgba(59, 130, 246, 0.6) 50%,
        transparent 100%);
    box-shadow: 0 0 20px rgba(59, 130, 246, 0.8);
  }
}

.nx-footer-copyright {
  font-size: 13px;
  color: #64748b;
  text-align: center;
  font-weight: 500;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

@media (max-width: 1024px) {
  .nx-footer {
    padding: 70px 30px 35px;
  }

  .nx-footer-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .nx-footer-contact-list {
    width: 100%;
    gap: 16px;
  }

  .nx-footer-wechat-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .nx-footer {
    padding: 50px 20px 25px;
  }

  .nx-footer-header {
    margin-bottom: 30px;
  }

  .nx-footer-content {
    gap: 40px;
  }

  .nx-footer-contact-list {
    width: 100%;
    gap: 20px;
  }

  .nx-footer-item {
    padding: 5px 24px;
    align-items: center;
  }

  .nx-footer-icon {
    width: 44px;
    height: 44px;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  .nx-footer-text {
    align-items: center;
    text-align: center;
  }

  .nx-footer-wechat-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .nx-footer-wechat-card {
    padding: 20px 16px;
  }
}
</style>
